import React from "react";

var cartSvg = function cartSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5 16a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm8 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zM2.216 2H1a1 1 0 1 1 0-2h2a1 1 0 0 1 .762.352.997.997 0 0 1 .345.64l.259 2.11 10.781.798c.55.04.894.52.853 1.07-.005.068-.498 1.543-1.62 4.426a1 1 0 0 1-.885.634l-9.233.424A1 1 0 0 1 3.22 9.55L2.216 2z",
    fillRule: "evenodd"
  }));
};

cartSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var cart = {
  category: 'icon',
  colorable: true,
  name: 'cart',
  svg: cartSvg
};